import { Box, CircularProgress, Container, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import AddCoinsDialog from "src/components/profile/AddCoinsDialog";
import AddTicketsDialog from "src/components/profile/AddTicketsDialog";
import AddXpDialog from "src/components/profile/AddXpDialog";
import AllAccessPassDialog from "src/components/profile/AllAccessPassDialog";
import CreateLeagueDialog from "src/components/profile/CreateLeagueDialog";
import ImitateLoginDialog from "src/components/profile/ImitateLoginDialog";
import JoinLeagueDialog from "src/components/profile/JoinLeagueDialog";
import LoginStreakDateDialog from "src/components/profile/LoginStreakDateDialog";
import ProfileTabsSection from "src/components/profile/ProfileTabsSection";
import ProfileUserData from "src/components/profile/ProfileUserData";
import ProfileUserStats from "src/components/profile/ProfileUserStats";
import ReferralCodeDialog from "src/components/profile/ReferralCodeDialog";
import { get, post, put } from "src/utils/networkUtils";
import { useAppSearchParams } from "../hooks/useAppSearchParams";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
export default function ProfilePage() {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(false);
	const [transactions, setTransactions] = useState(null);
	// const [ticketTransactions, setTicketTransactions] = useState(null);
	const [purchases, setPurchases] = useState([]);
	// const [referralRewards, setReferralRewards] = useState(null);
	// const [xpRewards, setXpRewards] = useState(null);
	const [messages, setMessages] = useState(null);
	const [openAddCoinsDialog, setOpenAddCoinsDialog] = useState(false);
	const [openAddTicketsDialog, setOpenAddTicketsDialog] = useState(false);
	const [openReferralCodeDialog, setOpenReferralCodeDialog] = useState(false);
	const [openCreateLeagueDialog, setOpenCreateLeagueDialog] = useState(false);
	const [openJoinLeagueDialog, setOpenJoinLeagueDialog] = useState(false);
	const [openLoginStreakDatesDialog, setOpenLoginStreakDatesDialog] = useState(false);
	const [openImitateLoginDialog, setOpenImitateLoginDialog] = useState(false);
	const [addCoinsAmount, setAddCoinsAmount] = useState(0);
	const [addTicketsAmount, setAddTicketsAmount] = useState(0);
	const [referralCode, setReferralCode] = useState("");
	const [leagueName, setLeagueName] = useState("");
	const [leagueCode, setLeagueCode] = useState("");
	const [loginStreakDates, setLoginStreakDates] = useState({
		loginStreakStartDate: moment().format(dateFormat),
		lastLoginDate: moment().format(dateFormat),
	});
	const [loginDate, setLoginDate] = useState({
		date: moment().format(dateFormat),
	});
	const [value, setValue] = useState(0);
	const [openAllAccessPassDialog, setOpenAllAccessPassDialog] = useState(false);
	const [storePrice, setStorePrice] = useState("1299");
	const [storeType, setStoreType] = useState("Apple");
	const [openAddXpDialog, setOpenAddXpDialog] = useState(false);
	const [addXpAmount, setAddXpAmount] = useState(0);

	const [error, setError] = useState("");

	const { userId } = useAppSearchParams();

	useEffect(() => {
		if (!userId) {
			setError("Need user ID provided");
			return;
		}

		get(`/admin/users/${userId}`).then((response) => {
			setUser(response.user);
			setLoginStreakDates({
				loginStreakStartDate: moment(response.user?.loginStreakStartUtc).format(dateFormat),
				lastLoginDate: moment(response.user?.lastLoginUtc).format(dateFormat),
			});
		});
		get(`/admin/users/${userId}/coin-transactions?offset=0&limit=200`).then((response) => {
			setTransactions(response.transactions);
		});
		get(`/admin/users/${userId}/store-purchases?offset=0&limit=100`).then((response) => {
			setPurchases(response.purchases);
		});

		// get(`/admin/users/${userId}/ticket-transactions?offset=0&limit=100`).then(
		//   function (response) {
		//     setTicketTransactions(response.transactions);
		//   }
		// );

		// get(`/admin/users/${userId}/rewards?rewardType=referral`).then(function (
		//   response
		// ) {
		//   setReferralRewards(response.rewards);
		// });

		// get(`/admin/users/${userId}/rewards?rewardType=xp`).then(function (
		//   response
		// ) {
		//   setXpRewards(response.rewards);
		// });

		get(`/admin/user-inbox-messages/${userId}?offset=0&limit=100`).then((response) => {
			setMessages(response.userInboxMessages);
		});
	}, [userId]);

	const handleChangeTabs = (event, newValue) => {
		setValue(newValue);
	};

	const addCoinsHandler = () => {
		post(`/admin/coins/add`, {
			userId,
			amount: +addCoinsAmount,
			tenantId: 1,
		}).then(() => {
			window.location.reload();
		});
	};
	const addXpHandler = () => {
		post(`/admin/xp/add`, {
			userId,
			amount: addXpAmount,
			tenantId: 1,
		}).then(() => {
			window.location.reload();
		});
	};

	const addAllAccessPassHandler = () => {
		post(`/admin/all-access/add`, {
			userId,
			tenantId: 1,
			price: storePrice,
			store: storeType,
		}).then(() => {
			window.location.reload();
		});
	};
	const addTicketsHandler = () => {
		post(`/admin/tickets/add`, {
			userId,
			amount: addTicketsAmount,
			tenantId: 1,
		}).then(() => {
			window.location.reload();
		});
	};
	const addReferralCodeHandler = () => {
		post(`/admin/users/${userId}/add-referral-code`, {
			referralCode,
		}).then(() => {
			window.location.reload();
		});
	};

	const updateLoginStreakDatesHandler = () => {
		setLoading(true);
		setOpenLoginStreakDatesDialog(false);
		put(`/admin/users/${userId}/login-dates`, {
			loginStreakStartDate: loginStreakDates.loginStreakStartDate,
			lastLoginDate: loginStreakDates.lastLoginDate,
		}).then(() => {
			window.location.reload();
		});
	};
	const imitateLoginHandler = () => {
		setLoading(true);
		setOpenImitateLoginDialog(false);
		post(`/admin/users/${userId}/imitate-login`, {
			date: loginDate.date,
		}).then(() => {
			window.location.reload();
		});
	};
	const createLeagueHandler = () => {
		setLoading(true);
		setOpenCreateLeagueDialog(false);
		post(`/admin/users/${userId}/leagues`, {
			name: leagueName,
		}).then(() => {
			window.location.reload();
		});
	};
	const joinLeagueHandler = () => {
		setLoading(true);
		setOpenJoinLeagueDialog(false);
		post(`/admin/users/${userId}/join-league`, {
			code: leagueCode,
		}).then(() => {
			window.location.reload();
		});
	};

	const handleDateChange = (newValue, fieldName) => {
		setLoginStreakDates((prevState) => ({
			...prevState,
			[fieldName]: moment(newValue).format(dateFormat),
		}));
	};
	const handleLoginDateChange = (newValue, fieldName) => {
		setLoginDate((prevState) => ({
			...prevState,
			[fieldName]: moment(newValue).format(dateFormat),
		}));
	};

	const updateUserField = (field, value) => {
		if (!userId) return;

		const updatedUser = {
			...user,
			[field]: value,
		};

		put(`/admin/users/${userId}`, { ...updatedUser })
			.then((response) => {
				setUser(updatedUser);
			})
			.catch((err) => {
				console.error("Error updating user:", err.response?.data || err.message);
			});
	};

	return (
		<>
			<Helmet>
				<title> Profile </title>
			</Helmet>
			<Container maxWidth="xl">
				{loading ? (
					<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
						<CircularProgress />
					</Box>
				) : error ? (
					<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
						<Typography variant="h6" color="error">
							{error}
						</Typography>
					</Box>
				) : (
					<>
						{user && <ProfileUserData user={user} onSaveField={updateUserField} />}
						{user && <ProfileUserStats user={user} />}

						<Grid container spacing={3}>
							<ProfileTabsSection
								value={value}
								handleChangeTabs={handleChangeTabs}
								userId={userId}
								transactions={transactions}
								purchases={purchases}
								messages={messages}
								setOpenAddCoinsDialog={setOpenAddCoinsDialog}
								setOpenAllAccessPassDialog={setOpenAllAccessPassDialog}
								setOpenReferralCodeDialog={setOpenReferralCodeDialog}
								setOpenAddXpDialog={setOpenAddXpDialog}
								setOpenAddTicketsDialog={setOpenAddTicketsDialog}
							/>
						</Grid>
					</>
				)}
			</Container>
			{openAddCoinsDialog && (
				<AddCoinsDialog
					open={openAddCoinsDialog}
					addCoinsAmount={addCoinsAmount}
					setAddCoinsAmount={setAddCoinsAmount}
					addCoinsHandler={addCoinsHandler}
					setOpenAddCoinsDialog={setOpenAddCoinsDialog}
				/>
			)}

			{openAddXpDialog && (
				<AddXpDialog
					open={openAddXpDialog}
					setOpen={setOpenAddXpDialog}
					addXpAmount={addXpAmount}
					setAddXpAmount={setAddXpAmount}
					addXpHandler={addXpHandler}
				/>
			)}

			{openAddTicketsDialog && (
				<AddTicketsDialog
					open={openAddTicketsDialog}
					onClose={() => setOpenAddTicketsDialog(false)}
					addTicketsAmount={addTicketsAmount}
					setAddTicketsAmount={setAddTicketsAmount}
					addTicketsHandler={addTicketsHandler}
				/>
			)}
			{openLoginStreakDatesDialog && (
				<LoginStreakDateDialog
					open={openLoginStreakDatesDialog}
					onClose={() => setOpenLoginStreakDatesDialog(false)}
					loginStreakDates={loginStreakDates}
					handleDateChange={handleDateChange}
					updateLoginStreakDatesHandler={updateLoginStreakDatesHandler}
				/>
			)}

			{openImitateLoginDialog && (
				<ImitateLoginDialog
					open={openImitateLoginDialog}
					onClose={() => setOpenImitateLoginDialog(false)}
					onConfirm={imitateLoginHandler}
					loginDate={loginDate}
					handleLoginDateChange={handleLoginDateChange}
				/>
			)}
			{openReferralCodeDialog && (
				<ReferralCodeDialog
					open={openReferralCodeDialog}
					onClose={() => setOpenReferralCodeDialog(false)}
					referralCode={referralCode}
					setReferralCode={setReferralCode}
					onAdd={addReferralCodeHandler}
				/>
			)}
			{openCreateLeagueDialog && (
				<CreateLeagueDialog
					open={openCreateLeagueDialog}
					onClose={() => setOpenCreateLeagueDialog(false)}
					leagueName={leagueName}
					setLeagueName={setLeagueName}
					onCreate={createLeagueHandler}
				/>
			)}

			{openJoinLeagueDialog && (
				<JoinLeagueDialog
					open={openJoinLeagueDialog}
					onClose={() => setOpenJoinLeagueDialog(false)}
					onJoin={joinLeagueHandler}
					leagueCode={leagueCode}
					setLeagueCode={setLeagueCode}
				/>
			)}

			{openAllAccessPassDialog && (
				<AllAccessPassDialog
					open={openAllAccessPassDialog}
					onClose={() => setOpenAllAccessPassDialog(false)}
					onSubmit={addAllAccessPassHandler}
					storePrice={storePrice}
					setStorePrice={setStorePrice}
					storeType={storeType}
					setStoreType={setStoreType}
				/>
			)}
		</>
	);
}
